import React, { useState } from 'react';
import { Box } from 'native-base';
import { useGeneralStyles } from '~/shared/styles';
import { Caption } from '~/shared/Typography';
import Barcode from 'react-barcode';
import Button from '~/shared/Button';
import Pressable from '~/shared/Pressable';

const BarcodeHolder = ({ cardNumber, cardPin }: { cardNumber: string, cardPin: string }) => {


    const gStyle = useGeneralStyles();
    const [showBarcode, setShowBarcode] = useState(false);

    return (
        <Box>
            {!showBarcode &&
                <Button
                    borderColor={gStyle.button_background}
                    borderWidth={1}
                    borderRadius={12}
                    width={150}
                    p={0}
                    alignSelf='center'
                    marginY={4}
                    onPress={() => setShowBarcode(prev => !prev)}
                >
                    <Caption
                        color={gStyle.button_background}
                        fontSize={22}
                        fontWeight={200}
                        text='giftCard.barcode.view'
                    />
                </Button>
            }
            <Pressable onPress={() => setShowBarcode(prev => !prev)} alignItems='center'>
                {showBarcode &&
                    <Box marginY={4} >
                        <Barcode value={cardNumber} format="CODE128" background='white' />
                    </Box>
                }
                {!showBarcode &&
                    <Caption
                        color={gStyle.button_background}
                        textAlign={'center'}
                        fontSize={16}
                    >
                        {cardNumber}
                    </Caption>
                }
            </Pressable>
            <Caption
                color={gStyle.button_background}
                textAlign={'center'}
                fontSize={16}
                text='giftCard.pinCode'
                textValues={[cardPin]}
            />
        </Box>
    );

};

export default BarcodeHolder;
